import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { Text } from 'ic-snacks'

import { type SeriesTypes } from 'legacy/components/DataViz/dataViz.types'
import { getSeriesColor } from 'legacy/components/DataViz/Charts/utils'

interface Props {
  labelText: string
  seriesType: SeriesTypes
}

const SeriesLegend = styled.div`
  margin-right: 20px;
  display: flex;
  align-items: center;
`
const SeriesLegendIcon = styled.div<{ color: string }>`
  height: 16px;
  width: 16px;
  margin-right: 10px;
  border-radius: 3px;
  background-color: ${({ color }) => color};
`

const ChartFooterLabel: FunctionComponent<Props> = ({ labelText, seriesType }) => (
  <SeriesLegend data-testid={`footer-label-${seriesType}`}>
    <SeriesLegendIcon color={getSeriesColor(seriesType)} />
    <Text variant="T.14" fontWeight="semiBold" elementType="span">
      {labelText}
    </Text>
  </SeriesLegend>
)

export default ChartFooterLabel
